export default __webpack_public_path__ + "static/media/categories_icon.4b201582.svg";